// extracted by mini-css-extract-plugin
export var lg = "_2x-4";
export var md = "_2x-3";
export var sm = "_2x-2";
export var xs = "_2x-1";
export var xxs = "_2x-0";